import React from "react";
import { TenantActivityContextProvider } from "./TenantActivityView";
import TenantActivity from "./views/TenantActivity";

const TenantActivityPage = () => {
  return (
    <TenantActivityContextProvider>
      <TenantActivity />
    </TenantActivityContextProvider>
  );
};

export default TenantActivityPage;
